import Empresa from "../pages/dashboard/Empresa";
import Clients from "../pages/dashboard/Clients";
import Proveidors from "../pages/dashboard/Proveidors";
import Empleats from "../pages/dashboard/Empleats";
import Pressupostos from "../pages/dashboard/Pressupostos";
import Plantilles from "../pages/dashboard/Plantilles";
import Treballs from "../pages/dashboard/Treballs";
import Fullstreballs from "../pages/dashboard/Fullstreballs";
import Productes from "../pages/dashboard/Productes";
import Materials from "../pages/dashboard/Materials";
import Tipusdematerials from "../pages/dashboard/Tipusdematerials";
import Categories from "../pages/dashboard/Categories";
import Tipusmaobra from "../pages/dashboard/Tipusmaobra";
import Grupsmaobra from "../pages/dashboard/Grupsmaobra";
import Usuaris from "../pages/dashboard/Usuaris";
import Agenda from "../pages/dashboard/Agenda";
import ContactesPage from "../pages/dashboard/ContactesPage";
import HorariEmpresa from "../pages/dashboard/HorariEmpresa";
import CalendariLaboral from "../pages/dashboard/CalendariLaboral";
import GestioEmpleat from "../pages/dashboard/GestioEmpleat";
import GestioLaboralEmpleats from "../pages/dashboard/GestioLaboralEmpleats";
import GestioLaboralControlHorari from "../pages/dashboard/GestioLaboralControlHorari";
import Tipusabsencia from "../pages/dashboard/Tipusabsencia";
import Tipuspausa from "../pages/dashboard/Tipuspausa";
import Vehicles from "../pages/dashboard/Vehicles";
import Eines from "../pages/dashboard/Eines";
import Magatzems from "../pages/dashboard/Magatzems";

const Rutesdashboard = [
  { path: "empresa", element: <Empresa /> },
  { path: "clients", element: <Clients /> },
  { path: "proveidors", element: <Proveidors /> },
  { path: "empleats", element: <Empleats /> },
  { path: "pressupostos", element: <Pressupostos /> },
  { path: "plantilles", element: <Plantilles /> },
  { path: "treballs", element: <Treballs /> },
  { path: "fullstreballs", element: <Fullstreballs /> },
  { path: "productes", element: <Productes /> },
  { path: "materials", element: <Materials /> },
  { path: "tipusdematerials", element: <Tipusdematerials /> },
  { path: "categories", element: <Categories /> },
  { path: "tipusmaobra", element: <Tipusmaobra /> },
  { path: "grupsmaobra", element: <Grupsmaobra /> },
  { path: "usuaris", element: <Usuaris /> },
  { path: "agenda", element: <Agenda /> },
  { path: "contactes", element: <ContactesPage /> },
  { path: "horariempresa", element: <HorariEmpresa /> },
  { path: "calendarilaboral", element: <CalendariLaboral /> },
  { path: "gestioempleat", element: <GestioEmpleat /> },
  { path: "gestiolaboralempleats", element: <GestioLaboralEmpleats /> },
  { path: "gestiolaboralcontrolhorari", element: <GestioLaboralControlHorari /> },
  { path: "tipusabsencia", element: <Tipusabsencia /> },
  { path: "tipuspausa", element: <Tipuspausa /> },
  { path: "vehicles", element: <Vehicles /> },
  { path: "eines", element: <Eines /> },
  { path: "magatzems", element: <Magatzems /> },
];

export default Rutesdashboard;
